'use strict';

(function(z, Backbone, _) {

    /**
     * Orders form
     */
    z.OrdersDuplicateForm = z.AttachmentFormView.extend({

        /**
         * Date format
         */
        DATE_FORMAT: 'DD-MM-YYYY',

        /**
         * Url from where the service form should be loaded
         */
        SERVICE_FORM_URL: '/orders/create/service/{service}/form',

        /**
         * The vendor dropdown value for allocating afterward
         */
        ALLOCATED_AFTERWARD_VALUE: 0,

        /**
         * Constants used to fill the sort field
         */
        SORT_BY_AVAILABILITY: 1,
        SORT_BY_DISTANCE: 2,

        /**
         * Bounding element
         */
        el: "#order-duplicate-create-form",

        /**
         * Events
         *
         * @return {undefined}
         */
        events: {
            'click #open-duplicate-order-modal-btn': '_displayCreateDuplicateOrderModal',
            'change #orderdupicateform-service-field': '_onServiceChange',
            'change #orderform-showroom-field': '_onShowroomChange',
            'click #order-duplicate-create': '_onFormSubmit',
            "click #order-create-duplicate-form-modal .close-link" : "_hideCreateDuplicateOrderModal",
        },

        /**
         * Constructor
         *
         * @return {undefined}
         */
        initialize: function(){

            this.$modalElement = this.$('#order-create-duplicate-form-modal');

            this.orderVendorsCollection = new z.VendorsCollection();


            this._prefillSeviceForm();

            Backbone.Validation.bind(this, {
                valid: this._onValid.bind(this),
                invalid: this._onInvalid.bind(this),
                model: this.model
            });

            this._bindChosen();

            this._initializeDateFields();

            this._addAllocatedAdfterwardOption();

            z.AttachmentFormView.prototype.initialize.apply(this, arguments);
        },

        /**
         * Initialize date fields
         * @return {undefined}
         * @private
         */
        _initializeDateFields: function() {

            $('#orderform-invoiceDate-field').daterangepicker({
                autoApply: true,
                autoUpdateInput: false,
                singleDatePicker: true,
                showDropdowns: true,
                maxDate: moment(),
                locale: {
                    format: this.DATE_FORMAT
                }
            });

            // this is official solution for initial empty field
            this.$('#orderform-invoiceDate-field').on('apply.daterangepicker', function (ev, picker) {
                this.$('#orderform-invoiceDate-field').val(picker.startDate.format(this.DATE_FORMAT));
            }.bind(this));

            this.$('#orderform-invoiceDate-field').on('cancel.daterangepicker', function () {
                $(this).val('');
            });
        },

        _displayCreateDuplicateOrderModal: function () {
            this.$modalElement.modal("show");
        },

        _hideCreateDuplicateOrderModal: function () {
            this.$modalElement.modal("hide");
        },

        /**
         * Prefill service form with the first available service
         * @return {undefined}
         * @private
         */
        _prefillSeviceForm: function() {

            this._onServiceChange();
        },

        /**
         * Method called if the form validation succeeds
         * @param {object} view The view
         * @param {string} attr The valid attribute
         * @return {undefined}
         * @private
         */
        _onValid: function(view, attr){

            var $form = this._getFormEl();

            $form
                .find('[data-validation="' + attr + '"]')
                .removeClass('has-error')
                .find('.help-block')
                .addClass('hidden')
                .text('');
        },

        /**
         * Method called if the form validation fails
         * @param {object} view The view
         * @param {string} attr The invalid attribute
         * @param {string} error The error message
         * @return {undefined}
         * @private
         */
        _onInvalid: function(view, attr, error){

            var $form = this._getFormEl();

            $form
                .find('[data-validation="' + attr + '"]')
                .addClass('has-error')
                .find('.help-block')
                .removeClass('hidden')
                .text(error);
        },



        /**
         * Method called after the service drop down gets changed
         * @return {undefined}
         * @private
         */
        _onServiceChange: function(){
            this._loadServiceForm();

            if (!z.security.isResellerAssociated()) {

                this._loadService();
            }
        },

        /**
         * Method that sets the service model for the selected service
         * @private
         * @return {undefined}
         */
        _loadService: function () {

            var serviceId = this._getFormRecord().service;

            if (serviceId) {

                this.service = new z.ServiceModel();

                this.service.set({id: serviceId});

                this.service.fetch();
            }
        },


        /**
         * Method called after the showroom gets changed
         * @return {undefined}
         * @private
         */
        _onShowroomChange: function() {

            this._loadShowroom( function() {

                this._displayInvoiceableEl();
            });
        },

        /**
         * Display the invoiceable element if it's valid
         * @private
         * @return {undefined}
         */
        _displayInvoiceableEl: function() {

            if (this._isValidForInvoice()) {

                this._toggleInvoiceableEl(true);

            } else {

                this._toggleInvoiceableEl(false);
            }
        },

        /**
         * Verify if the order is valid to be invoiceable or not
         * @return {boolean} Is valid to be invoiceable or not
         * @private
         */
        _isValidForInvoice: function() {
            // If the reseller can invoice and the command is not allocated afterwards
            if (this._canResellerInvoice() ) {

                return true;
            }

            return false;
        },

        /**
         * Verify if the reseller can invoice
         * @return {boolean} can invoice or not
         * @private
         */
        _canResellerInvoice: function() {

            if (_.isUndefined(this.showroom)) {

                return false;
            }

            var reseller = this.showroom.get('reseller');

            if (reseller.hasOwnProperty('canInvoice')) {

                return reseller.canInvoice;
            }

            return false;
        },

        /**
         * Method that sets the showroom model for the selected showroom
         * @param {function} callback the callback function
         * @private
         * @return {undefined}
         */
        _loadShowroom: function(callback) {

            callback = _.isFunction(callback) ? callback : _.noop;

            var showroomId = this._getFormRecord().showroom;

            if (showroomId) {

                this.showroom = new z.ShowroomModel();

                this.showroom.set({id: showroomId});

                this.showroom.fetch({
                    success: function(){

                        callback.apply(this, arguments);

                    }.bind(this),
                    error: function(){

                        callback.apply(this, arguments);

                    }.bind(this)
                });
            }
        },

        /**
         * Method called after the form is submitted
         * @param {object} event The jQuery event object
         * @return {undefined}
         * @private
         */
        _onFormSubmit: function(event){

            event.preventDefault();

            this._submitForm();
        },


        /**
         * Returns the jQuery form element
         * @return {object} The form element
         * @private
         */
        _getFormEl: function(){
            return this.$('#order-duplicate-create-form');
        },

        /**
         * Retrieves the service holder element
         * @returns {object} The service holder
         * @private
         */
        _getServiceContainerEl: function(){
            return this.$('#orderform-service-container');
        },

        /**
         * Retrieves the service dropdown element
         * @returns {object} The service holder
         * @private
         */
        _getServiceFieldEl: function(){
            return this.$('#orderdupicateform-service-field');
        },

        /**
         * Retrieves the quantity dropdown element
         * @returns {object} The quantity field
         * @private
         */
        _getQuantityFieldEl: function(){
            return this.$('#orderform-quantity-field');
        },

        /**
         * Retrieves the custody dropdown element
         * @returns {object} The quantity field
         * @private
         */
        _getCustodyFieldEl: function(){
            return this.$('#orderform-custody-field');
        },

        /**
         * Retrieves the file element
         * @returns {object} The file element
         * @private
         */
        _getFileFieldEl: function(){
            return this.$('#orderform-file-field');
        },

        /**
         * Retrieves all service params
         * @returns {object} The service holder
         * @private
         */
        _getServiceParamsEl: function(){
            return this._getServiceContainerEl().find(':input[name*="option_"]');
        },

        /**
         * Retrieves all service details
         * @returns {object} The service holder
         * @private
         */
        _getServiceDetailsEl: function(){
            return this._getServiceContainerEl().find(':input[name*="detail_"]');
        },

        /**
         * Retrieves the customer's county dropdown element
         * @returns {object} The locality field
         * @private
         */
        _getCustomerCountyFieldEl: function(){
            return this.$('#customerform-county-field');
        },

        /**
         * Retrieves the customer's locality dropdown element
         * @returns {object} The locality field
         * @private
         */
        _getCustomerLocalityFieldEl: function(){
            return this.$('#customerform-locality-field');
        },

        /**
         * Retrieves the order's vendor container element
         * @returns {object} The element
         * @private
         */
        _getVendorContainerEl: function(){
            return this._getVendorFieldEl().parent();
        },

        /**
         * Retrieves the offers sort field element
         * @returns {object} The element
         * @private
         */
        _getSortFieldEl: function(){
            return this.$('#orderform-sort-field');
        },

        /**
         * Retrieves the order's vendor field element
         * @returns {object} The element
         * @private
         */
        _getVendorFieldEl: function(){
            return this.$('#orderform-vendor-field');
        },

        /**
         * Retrieves the order's showroom field element
         * @returns {object} The element
         * @private
         */
        _getShowroomFieldEl: function(){
            return this.$('#orderform-showroom-field');
        },

        /**
         * Retrieves the order's showroom holder element
         * @returns {object} The element
         * @private
         */
        _getShowroomHolderEl: function(){
            return this.$('#orderform-showroom-field').parents('.form-group:first');
        },

        /**
         * Retrieves the order's invoiceable field element
         * @returns {object} The element
         * @private
         */
        _getInvoiceableFieldEl: function(){
            return this.$('#orderform-invoiceable-field');
        },

        /**
         * Retrieves the order's invoiceable container element
         * @returns {object} The element
         * @private
         */
        _getInvoiceableContainerEl: function(){
            return this.$('#orderform-invoiceable-container');
        },


        /**
         * Retrieves a list containing all the chosen fields from this page
         * @returns {Array} The list
         * @private
         */
        _getChosenFieldsEl: function(){
            var $customerCountyField = this._getCustomerCountyFieldEl();
            var $customerLocalityField = this._getCustomerLocalityFieldEl();
            var $showroomField = this._getShowroomFieldEl();
            var $vendorField = this._getVendorFieldEl();

            return [
                $customerCountyField,
                $customerLocalityField,
                $showroomField,
                $vendorField
            ];
        },

        /**
         * Retrieves the offers table element
         * @returns {object} The element
         * @private
         */
        _getOffersTableEl: function(){
            return this.$('#orderform-offers-table');
        },

        /**
         * Retrieves the offers table body element
         * @returns {object} The element
         * @private
         */
        _getOffersTableBodyEl: function(){
            return this._getOffersTableEl().find('tbody');
        },

        /**
         * Retrieves the offers empty element
         * @returns {object} The element
         * @private
         */
        _getOffersEmptyEl: function(){
            return this.$('#orderform-offers-empty');
        },

        /**
         * Retrieves the offers invalid element
         * @returns {object} The element
         * @private
         */
        _getOffersInvalidEl: function(){
            return this.$('#orderform-offers-invalid');
        },

        /**
         * Retrieves the checks from offers table
         * @returns {object} The element
         * @private
         */
        _getOffersChecksEl: function(){
            return this._getOffersTableBodyEl().find('input[type="radio"]');
        },

        /**
         * Retrieves the total field element
         * @returns {object} The element
         * @private
         */
        _getTotalFieldEl: function(){
            return this.$('#orderform-total-field');
        },

        /**
         * Retrieves the offer field element
         * @returns {object} The element
         * @private
         */
        _getOfferFieldEl: function(){
            return this.$('#orderform-offer-field');
        },

        /**
         * Retrieves the total display element
         * @returns {object} The element
         * @private
         */
        _getTotalDisplayEl: function(){
            return this.$('#orderform-total-display');
        },

        /**
         * Retrieves the normalized form data
         * @param {boolean} forOffers Return the offer record used for offers
         * @return {object} The form data
         * @private
         */
        _getFormRecord: function(forOffers){

            var offer = this._getOfferRecord();

            var record = {
                service: this._getServiceFieldEl().val(),
                fields: this._getServiceFormRecord(forOffers),
                customer: this._getCustomerFormRecord(),
                showroom: this._getShowroomFieldEl().val(),
                sort: this._getSortFieldEl().val(),
                vendor: this._getVendorFieldEl().val()
            };

            var $invoiceableField = this._getInvoiceableFieldEl();
            record['invoiceable'] = $invoiceableField.length ? $invoiceableField.is(':checked') : false;
            record['orderId'] = $('#order-duplicate-id').val();

            if (!forOffers) {
                
                var invoiceDate = this.$('#orderform-invoiceDate-field').val();

                if (invoiceDate !== 'undefined' && invoiceDate) {
                    invoiceDate = moment(this.$('#orderform-invoiceDate-field').val(), this.DATE_FORMAT);
                }

                record.extraObservations = this.$('#customerform-extraObservations-field').val();
                record.invoiceNumber = this.$('#orderform-invoiceNumber-field').val();
                record.invoiceDate = invoiceDate;
                record.offer = offer.id;
            }

            return record;
        },

        /**
         * Retrieves the normalized service form data
         * @param {boolean} forOffers Return the offer record used for offers
         * @returns {object} The customer
         * @private
         */
        _getServiceFormRecord: function(forOffers){
            var record = {};

            var $params = this._getServiceParamsEl();
            var $details = this._getServiceDetailsEl();
            var $quantityField = this._getQuantityFieldEl();
            var $custodyField = this._getCustodyFieldEl();
            var $fileField = this._getFileFieldEl();
            var $fields = $().add($params).add($details);

            $fields.each(function(index, element){

                var $element = $(element);

                var name = this._getServiceParamName($element.attr('name'));

                record[name] = $element.val();

            }.bind(this));

            if ($quantityField.length) {

                var quantity = parseInt($quantityField.val());

                if (_.isNaN(quantity)) {
                    quantity = 0;
                }

                record['quantity'] = quantity ? '' + quantity : null; // be sure not to have NaN and convert to string
            }

            if ($custodyField.length) {

                record['custody'] = $custodyField.val();
            }

            if (!forOffers && $fileField.length) {

                var file = $fileField.get(0).files[0];

                if (file) {

                    record['file'] = file;
                }
            }

            return record;
        },

        /**
         * Retrieves the normalized customer form data
         * @returns {object} The customer
         * @private
         */
        _getCustomerFormRecord: function(){
            // var $form = this._getFormEl();

            return {
                name: $('#order-duplicate-customer-name').val(),
                phoneNumber: $('#order-duplicate-customer-phoneNumber').val(),
                vendor: $('#order-duplicate-vendor').val(),
                email: $('#order-duplicate-customer-email').val(),
                county: $('#order-duplicate-customer-county').val(),
                locality: $('#order-duplicate-customer-locality').val(),
                // locality: this._getCustomerLocalityFieldEl().val(),
                address: $('#order-duplicate-customer-address').val(),
            };
        },

        /**
         * Retrieves the record form with the offer
         * @returns {object} The offer
         * @private
         */
        _getOfferRecord: function(){
            var $checked = this._getOffersChecksEl().filter(':checked');

            if (!$checked.length) {

                return {
                    id: null,
                    total: null,
                    transport: null
                };
            }

            var $row = $checked.parents('tr:first');

            return {
                id: $row.data('id'),
                total: $row.data('total'),
                transport: $row.data('transport')
            };
        },


        /**
         * Returns the appropriate field name
         * @param {string} fieldName The original field name
         * @returns {string} The real field name
         * @private
         */
        _getServiceParamName: function(fieldName){
            var pattern = /\[([a-z]+_\d+)\]$/g;

            var result = pattern.exec(fieldName);

            return result[1];
        },

        /**
         * Returns the url where you can find the service form
         * @param {int|string} serviceId The service id
         * @returns {string} The url
         * @private
         */
        _getServiceFormUrl: function(serviceId){
            return this.SERVICE_FORM_URL.replace('{service}', serviceId);
        },

        /**
         * Show or hide the invoiceable field
         * @param {boolean} override Override the toggle logic and turn it on or off by yourself
         * @return {undefined}
         * @private
         */
        _toggleInvoiceableEl: function(override) {

            var $el = this._getInvoiceableContainerEl();
            var $invoiceableEl = this._getInvoiceableFieldEl();

            // Check it if visible, uncheck if not
            // todo uncomment this line if the invoiceable field should be checked by default
            // $invoiceableEl.prop('checked', override);
            $invoiceableEl.removeAttr('checked');

            this._toggle($el, true, override);
        },

        /**
         * Show or hide the offers empty element
         * @param {boolean} override Override the toggle logic and turn it on or off by yourself
         * @return {undefined}
         * @private
         */
        _toggleOffersEmpty: function(override){
            var $el = this._getOffersEmptyEl();

            $el.text(Translator.trans('js.label_no_offers'));

            this._toggle($el, true, override);
        },

        /**
         * Show or hide the offers invalid element
         * @param {boolean} override Override the toggle logic and turn it on or off by yourself
         * @return {undefined}
         * @private
         */
        _toggleOffersInvalid: function(override){
            var $el = this._getOffersInvalidEl();

            this._toggle($el, true, override);
        },

        /**
         * Enable or disable fields associated with generating the offer
         * @return {undefined}
         * @private
         */
        _toggleOfferAssociatedFields: function(){
            var $service = this._getServiceFieldEl();
            var $params = this._getServiceParamsEl();
            var $county = this._getCustomerCountyFieldEl();
            var $locality = this._getCustomerLocalityFieldEl();
            var $quantity = this._getQuantityFieldEl();
            var $custody = this._getCustodyFieldEl();
            var $vendor = this._getVendorFieldEl();
            var $sort = this._getSortFieldEl();

            var list = [
                $service,
                $params,
                $quantity,
                $custody,
                $county,
                $locality,
                $vendor,
                $sort
            ];

            this._toggle(list);
        },

        /**
         * Enable/disable or show/hide a form field
         * @param {object} $fields The field
         * @param {boolean} display The type of toggle: true for display, false for state
         * @param {boolean} override Override the toggle logic and turn it on or off by yourself
         * @return {undefined}
         * @private
         */
        _toggle: function($fields, display, override){
            $fields = _.isArray($fields) ? $fields : [$fields];

            _.each($fields, function($field){

                var show = function(){
                    $field.removeClass('hidden');
                };

                var hide = function(){
                    $field.addClass('hidden');
                };

                var enable = function(){
                    $field.removeAttr('disabled');
                };

                var disable = function(){
                    $field.attr('disabled', 'disabled');
                };

                var isToggled = _.isUndefined(override) ? this._isToggled($field, display) : !override;
                var toggleOn = display ? show : enable;
                var toggleOff = display ? hide : disable;

                if (isToggled) {

                    toggleOff();

                } else {

                    toggleOn();
                }

                $field.trigger('chosen:updated');

            }, this);
        },

        /**
         * Returns true if the supplied filed is toggled, false otherwise
         * @param {object} $field The field
         * @param {boolean} display The type of toggle: true for display, false for state
         * @returns {boolean} The status
         * @private
         */
        _isToggled: function($field, display){
            var isDisabled = $field.attr('disabled');
            var isHidden = $field.hasClass('hidden');

            return display ? !isHidden : !isDisabled;
        },

        /**
         * Binds the chosen to the select fields
         * @return {undefined}
         * @private
         */
        _bindChosen: function(){
            this._getCustomerCountyFieldEl().chosen({ width: '100%' });
            this._getCustomerLocalityFieldEl().chosen({ width: '100%' });
            this._getShowroomFieldEl().chosen({ width: '100%' });
            this._getVendorFieldEl().chosen({ width: '100%' });
        },


        /**
         * Loads the service form according to the service dropdown
         * @return {undefined}
         * @private
         */
        _loadServiceForm: function(){

            var record = this._getFormRecord();
            var serviceId = record.service;
            var $holder = this._getServiceContainerEl();
            var toggle = this._toggleOfferAssociatedFields.bind(this); // this._toggleServiceField();

            $holder.empty();
            if (!serviceId) {

                return false;
            }

            var url = this._getServiceFormUrl(serviceId);
            var opts = {
                method      : 'GET',
                dataType    : 'html',
                contentType : 'text/plain'
            };

            toggle();

            z.request.make(url, null, function(jqXhr, status){

                toggle();

                if (status !== 'success') {
                    return false;
                }

                $holder.append(jqXhr.responseText);


            }.bind(this), opts);
        },

        /**
         * Checks if all required fields for an offer request are not empty
         * @return {boolean} Is valid
         * @private
         */
        _isValidOfferRequest: function(){

            this._prepareModelData(this.model);

            var serviceFields = this._getServiceRequiredFields(this.model);
            var record = this._getFormRecord();

            var isServiceFieldEmpty = _.find(serviceFields, function(field){

                if (field === 'file') {

                    return false;
                }

                return !record.fields[field];
            });

            if (isServiceFieldEmpty) {
                return false;
            }

            var serviceId = record.service;

            if (!serviceId) {
                return false;
            }

            var countyId = record.customer.county;

            if (!countyId) {
                return false;
            }

            var localityId = record.customer.locality;

            if (!localityId) {
                return false;
            }

            var showroomId = record.showroom;

            // Verify the showroom only if the user is nor reseller operator
            if (!showroomId && !z.security.isResellerOperator()) {
                return false;
            }

            return true;
        },

        /**
         * Checks if all required fields for a vendor request are not empty
         * @return {boolean} Is valid
         * @private
         */
        _isValidVendorRequest: function(){

            var record = this._getFormRecord();

            var quantity = record.fields.quantity;

            if (!_.isUndefined(quantity) && !quantity) {
                return false;
            }

            var serviceId = record.service;

            if (!serviceId) {
                return false;
            }

            var countyId = record.customer.county;

            if (!countyId) {
                return false;
            }

            return true;
        },

        /**
         * Checks if the vendor container field is visible
         * @return {boolean} Is visible
         * @private
         */
        _isVendorFieldVisible: function(){

            var $container = this._getVendorContainerEl();

            return !$container.is('.hidden');
        },

        /**
         * Renders the options inside the chosen field based on the supplied collection
         * @param {object} $field The select field
         * @param {Backbone.Collection} collection The collection
         * @param {string|function} name How to select the name of the item
         * @return {undefined}
         * @private
         */
        _renderChosenField: function($field, collection, name){

            if (!collection) {

                $field.trigger('chosen:updated');

                return false;
            }

            var $placeholder = $field.find('option:first').detach();

            var options = [$placeholder];

            $field.empty();

            // Add the allocated afterward option
            if ($field.attr('id') === 'orderform-vendor-field') {

                var $allocatedAfterwardOption = this._getAllocatedAfterwardOption();
                options.push($allocatedAfterwardOption);
            }

            collection.each(function(item){

                var display;

                if (_.isFunction(name)) {
                    display = name.call(this, item);
                } else {
                    display = item.get(name);
                }

                var $option = $('<option>')
                    .attr('value', item.get('id'))
                    .text(display);

                options.push($option);
            });

            $field.append(options);

            $field.trigger('chosen:updated');
        },



        /**
         * Displays the appropriate offer error based on response
         * @param {object} res The response
         * @return {undefined}
         * @private
         */
        _displayOffersError: function(res){

            if (!res.responseJSON || !res.responseJSON.errors || res.responseJSON.errors.length === 0) {

                this._showOfferError(Translator.trans('js.error_message_orderform_offers_unknown_error'));

                return false;
            }

            var errors = res.responseJSON.errors;
            var exception = _.first(errors).class;

            switch (exception) {
                case 'OrderBundle\\Service\\Pricing\\Exception\\OfferUnavailableException':
                case 'Symfony\\Component\\HttpKernel\\Exception\\NotFoundHttpException':
                    this._showOfferError(Translator.trans('js.error_message_orderform_offers_unavailable'));
                    return false;
                case 'OrderBundle\\Exceptions\\VendorUnavailableException':
                    this._showOfferError(Translator.trans('js.error_message_vendorform_vendor_unavailable'));
                    return false;
                default:
                    this._showOfferError(Translator.trans('js.error_message_orderform_offers_unknown_error'));
                    return false;
            }
        },

        /**
         * Displays the appropriate error based on response
         * @param {object} res The response
         * @return {undefined}
         * @private
         */
        _displayError: function(res){

            this._hideError();

            if (!res.responseJSON || !res.responseJSON.errors || res.responseJSON.errors.length === 0) {

                this._showError(Translator.trans('js.error_message_orderform_order_unknown_error'));

                return false;
            }

            var errors = res.responseJSON.errors;

            if (errors.length === 1) {

                var exception = _.first(errors).class;
                var message = _.first(errors).message;

                if (typeof exception !== 'undefined') {

                    switch (exception) {
                        case 'OrderBundle\\Service\\Pricing\\Exception\\OfferUnavailableException':
                        case 'Symfony\\Component\\HttpKernel\\Exception\\NotFoundHttpException':
                            this._showError(Translator.trans('js.error_message_orderform_offers_unavailable'));
                            return false;
                        case 'OrderBundle\\Exceptions\\VendorUnavailableException':
                            this._showError(Translator.trans('js.error_message_orderform_vendor_unavailable'));
                            return false;
                        default:
                            this._showError(Translator.trans('js.error_message_orderform_order_unknown_error'));
                            return false;
                    }
                }

                if (typeof message !== 'undefined') {

                    switch (message) {
                        case "future_invoice_date":
                            this._showError(Translator.trans('js.error_message_order_editable_invoice_date'));
                            return false;
                        case "no_tariff_vendor_defined":
                            this._showError(Translator.trans('js.no_tariff_vendor_defined'));
                            return false;
                        case "no_tariff_reseller_defined":
                            this._showError(Translator.trans('js.no_tariff_reseller_defined'));
                            return false;
                    }
                }
            }

            _.each(errors, function(value) {

                if (value.field === "children[fields].children[file].data") {
                    this._showError(Translator.trans('js.error_message_attachmentform_name_invalidtype'));
                }

            }.bind(this));
        },

        /**
         * Method that returns the offer distance.
         * @param {object} offer - the offer object
         * @private
         * @return {float} - the distance
         */
        _renderDistance: function (offer) {
            return offer.get('distance');
        },

        /**
         * Method that builds the name of the vendor from brandName and Company name
         * @param {object} offer - the offer object
         * @return {string} the vendor name
         * @private
         */
        _getVendorNameFromOffer: function (offer) {
            return offer.get('worksite').vendor.companyName;
        },

        /**
         * Retrieves the distance th element
         * @private
         * @return {object} - the distance element
         */
        _getOrderTableThDistance: function () {
            return this.$('#order-offers-table-th-distance ');
        },

        /**
         * Retrieves the transport cost th element
         * @private
         * @return {object} - the transport el
         */
        _getOrderTableThTransport: function () {
            return this.$('#order-offers-table-th-transport');
        },

        /**
         * Retrieves the vendor th element
         * @private
         * @return {object} -the  vendor el
         */
        _getOrderTableThVendor: function () {
            return this.$('#order-offers-table-th-vendor');
        },

        /**
         * Renders a date as string
         * @param {string} value The string representation of the date
         * @return {string} The formatted date
         * @private
         */
        _renderDate: function(value){
            // TODO: we should get the locale for current user
            return moment(value).locale('ro').format('dddd, D MMMM');
        },

        /**
         * Renders the price accordingly
         * @param {string|int} value The price
         * @return {string} The formatted price
         * @private
         */
        _renderPrice: function(value){
            return value;
        },

        /**
         * Prepare model with all the necessary fields
         * @param {object} model The model
         * @return {undefined}
         * @private
         */
        _prepareModelData: function(model){

            var record = this._getFormRecord();

            model.clear();

            model.set(record);
        },

        /**
         * Sets the fields which the validation will check
         * @param {object} model The model
         * @return {undefined}
         * @private
         */
        _prepareModelValidation: function(model){
            var $showroomHolder = this._getShowroomHolderEl();

            var isResellerRequired = this._isToggled($showroomHolder, false);

            var serviceRequiredFields = this._getServiceRequiredFields(model);

            this._removeAllServiceFieldValidations(model);

            _.each(serviceRequiredFields, function(name){

                this._addServiceFieldValidation(name, model);

            }, this);

            this.model.set({
                isResellerRequired: isResellerRequired
            });
        },

        /**
         * Returns a list containing all the required service fields
         * @param {object} model The model
         * @returns {Array} The list
         * @private
         */
        _getServiceRequiredFields: function(model){
            var data = model.toJSON();
            var fields = data.fields;

            var result = [];

            _.each(fields, function(value, name){

                if (!this._isServiceFieldRequired(name)) {

                    return false;
                }

                result.push(name);

            }, this);

            return result;
        },

        /**
         * Returns true if the supplied service field name is required, false otherwise
         * @param {string} name The service field name
         * @returns {boolean} The result
         * @private
         */
        _isServiceFieldRequired: function(name){
            if (name.indexOf('option') === 0) {

                return true;
            }

            var $container = this._getServiceContainerEl();

            return !!$container.find(':input[name*="\[' + name + '\]"]').attr('required');
        },

        /**
         * Deletes all validations belonging to service fields
         * @param {object} model The model
         * @return {undefined}
         * @private
         */
        _removeAllServiceFieldValidations: function(model){

            if (!model.validation) {
                return false;
            }

            _.each(model.validation, function(validation, name){

                if (name.indexOf('fields.') !== 0) {
                    return false;
                }

                delete model.validation[name];
            });
        },

        /**
         * Add validation to service field
         * @param {string} name The name of the field
         * @param {object} model The model
         * @return {undefined}
         * @private
         */
        _addServiceFieldValidation: function(name, model){

            var fieldName = 'fields.' + name;

            if( name.indexOf('option') === 0 ){

                model.validation[fieldName] = [{
                    required: true,
                    msg: Translator.trans('js.error_message_orderform_service_param_required')
                }];

                return false;
            }

            if( name.indexOf('detail') === 0 ){

                model.validation[fieldName] = [{
                    required: true,
                    msg: Translator.trans('js.error_message_orderform_service_detail_required')
                }, {
                    minLength: 4,
                    msg: Translator.trans('js.error_message_orderform_service_detail_minlength')
                }];

                return false;
            }

            model.validation[fieldName] = [{
                required: true,
                msg: Translator.trans('js.error_message_orderform_service_field_required')
            }];
        },

        /**
         * Submit the form
         * @return {undefined}
         * @private
         */
        _submitForm: function(){

            this._prepareModelData(this.model);

            this._prepareModelValidation(this.model);

            var $fileField = this._getFileFieldEl();


            var dataOptions = this._getFormDataRecord();
            dataOptions.append('orderId', $('#order-duplicate-id').val());
            var options = {
                type: "POST",
                data: dataOptions,
                processData: false,
                contentType: false,
                validate: false
            };

            this.model.save(null, $.extend({}, options, {
                success: function(model, response){

                    this._displayMessageWithOrderLink(response.data.hash);


                    this._prefillSeviceForm();
                    setTimeout(function () {
                        location.reload();
                    },3000);
                    if (!z.security.isResellerOperator()) {

                        this._toggleInvoiceableEl(false);
                    } else {

                        this._toggleInvoiceableEl(true);
                    }

                }.bind(this),
                error: function(model, res) {


                    this._displayError(res);

                }.bind(this)
            }));
        },

        /**
         * Retrieves the FormData record
         * @returns {FormData} The form data
         * @private
         */
        _getFormDataRecord: function(){

            var name = this.$('form').attr('name');
            var data = new FormData();

            data.append(name + '[extraObservations]', this.model.get('extraObservations'));
            data.append(name + '[invoiceNumber]', this.model.get('invoiceNumber'));
            data.append(name + '[invoiceDate]', this.model.get('invoiceDate'));
            data.append(name + '[offer]', this.model.get('offer'));
            data.append(name + '[showroom]', this.model.get('showroom'));
            data.append(name + '[service]', this.model.get('service'));

            if (this.model.get('invoiceable')) {
                data.append(name + '[invoiceable]', true);
            }

            _.each(this.model.get('fields'), function(value, key) {

                data.append(name + '[fields]' + '[' + key + ']', value);
            });

            _.each(this.model.get('customer'), function(value, key) {

                data.append(name + '[customer]' + '[' + key + ']', value);
            });

            return data;
        },

        /**
         * Display the success message with a link to see the order
         *
         * @param {String} hash - order hash
         * @return {undefined}
         * @private
         */
        _displayMessageWithOrderLink: function(hash) {
            var message = Translator.trans('js.success_message_orders');
            var orderLink = '<strong><a href="/orders/' + hash + '" target="_blank">' + hash + '</a></strong>';

            this._showSuccess(message.replace('ORDER_LINK', orderLink));
        },


        /**
         * Sets the offer into the form
         * @param {string} offer The offer id
         * @return {undefined}
         * @private
         */
        _setOffer: function(offer){

            var $field = this._getOfferFieldEl();

            $field.val(offer);
        },

        /**
         * Sets the total price with the specified value
         * @param {string|int|null} total The total price
         * @param {string|int} transport the transport cost
         * @return {undefined}
         * @private
         */
        _setTotal: function(total, transport) {

            var $field = this._getTotalFieldEl();
            var $display = this._getTotalDisplayEl();

            var $transportCost = this._transportCostEl();
            var $serviceValue = this._serviceValueEl();

            var showTransport = !z.security.isResellerAssociated() && this.service && this.service.get('hasTransportCost') === true && transport !== 0;

            var finalPrice = !total || total < 0 ? 0 : total;

            if (showTransport) {

                finalPrice += transport;

            }

            $field.val(finalPrice);

            $transportCost.text(this._renderPrice(transport));
            $serviceValue.text(this._renderPrice(total));
            $display.text(this._renderPrice(finalPrice));

            this._toggleTransportCostAndServiceValue(showTransport);
        },


        /**
         * Method that hide/show the transport cost and service value fields and their labels
         * @param {object} value is true for Show and false for hide
         * @private
         * @return {undefined}
         */
        _toggleTransportCostAndServiceValue: function (value) {

            var $wrapper = this.$('.orderform-total-service-transport');

            if (value) {
                $wrapper.removeClass('hidden');
            } else {
                $wrapper.addClass('hidden');
            }
        },

        /**
         * Retrieves the label object for the service-value element
         * @return {object} the object
         * @private
         */
        _serviceValueEl: function () {
            return this.$('#orderform-total-service-value');
        },

        /**
         * Retrieves the label object for the transport-cost element
         * @return {object} the object
         * @private
         */
        _transportCostEl: function () {
            return this.$('#orderform-total-transport-cost');
        },

        /**
         * Display the success message
         * @param {string} message The message to be displayed
         * @return {undefined}
         * @private
         */
        _showSuccess: function(message){

            this._hideError();

            var $success = this.$('#order-success-message');

            $success
                .html(message)
                .removeClass('hidden')
                .fadeOut(0)
                .fadeIn('slow')
                .delay(5000)
                .fadeOut('slow', function(){

                    $success.addClass('hidden');
                });
        },

        /**
         * Hide the success message
         * @return {undefined}
         * @private
         */
        _hideSuccess: function(){

            var $error = this.$('#order-success-message');

            $error
                .finish()
                .fadeOut(0)
                .addClass('hidden');
        },

        /**
         * Display the error message
         * @param {string} message The message to be displayed
         * @return {undefined}
         * @private
         */
        _showError: function(message){

            this._hideSuccess();

            var $error = this.$('#order-error-message');

            $error
                .text(message)
                .removeClass('hidden')
                .fadeOut(0)
                .fadeIn('slow')
                .delay(5000)
                .fadeOut('slow', function(){

                    $error.addClass('hidden');
                });
        },

        /**
         * Hide the error message
         * @return {undefined}
         * @private
         */
        _hideError: function(){

            var $error = this.$('#order-error-message');

            $error
                .finish()
                .fadeOut(0)
                .addClass('hidden');
        },

        /**
         * Shows the offer error
         * @param {string} message The message
         * @return {undefined}
         * @private
         */
        _showOfferError: function(message){

            var $error = this.$('#orderform-offers-error');

            $error
                .text(message)
                .removeClass('hidden')
                .slideUp(0)
                .slideDown()
                .delay(5000)
                .slideUp(function(){

                    $error.addClass('hidden');
                });
        },


        /**
         * Add allocated afterwards options
         * @return {undefined}
         * @private
         */
        _addAllocatedAdfterwardOption: function() {

            var $option = this._getAllocatedAfterwardOption();
            this.$('#orderform-vendor-field').append($option).trigger("chosen:updated");
        },

        /**
         * Get allocated afterward option
         * @return {*|jQuery} - return the allocated afterward option
         * @private
         */
        _getAllocatedAfterwardOption: function() {

            return $('<option>')
                .attr('value', this.ALLOCATED_AFTERWARD_VALUE)
                .text(Translator.trans('js.allocated_afterward'));
        }

    });

})(window.z = window.z || {}, Backbone, _);